
import React from "react";
import ForgotPasswordForm from "../componenets/forgotpassword/ForgotPasswordForm";

const ForgotPassword = () =>{
    return(<ForgotPasswordForm/>);
};

export default ForgotPassword;
